/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { FetchModelResponse, IFetchModel } from '@cian/http-api';
import type { IFilterResponseV3 } from '../../entities/filter/FilterResponseV3';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export interface IGetFiltersWebRequest {
  category?: EQueryParameters;
  dealType: EQueryParameters_1;
}

export enum EQueryParameters {
  /** Загородный участок **/
  'LandSale' = 'landSale',
  /** Загородный дом **/
  'HouseSale' = 'houseSale',
}
export enum EQueryParameters_1 {
  /** Продажа **/
  'Sale' = 'sale',
  /** Аренда **/
  'Rent' = 'rent',
}
export type TGetFiltersWebResponse =
  | FetchModelResponse<200, 'json', IFilterResponseV3>
  | FetchModelResponse<400, 'json', IErrorResponseSchema>;

export type TGetFiltersWebModel = IFetchModel<IGetFiltersWebRequest, undefined, TGetFiltersWebResponse>;

export interface IMappers<TResponse200, TResponse400> {
  200(response: IFilterResponseV3, headers: Headers): TResponse200;
  400(response: IErrorResponseSchema, headers: Headers): TResponse400;
}
